<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold"
          >update transporter truck</small
        >
      </legend>
      <div>
        <form @submit.prevent="truckUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input
                type="hidden"
                class="transporter_id"
                :value="Truck.transporter_id"
              />
              <input type="hidden" class="id" :value="Truck.id" />
              <div class="form-group">
                <label>Truck no</label>
                <input
                  type="text"
                  class="form-control truck_no"
                  :value="Truck.truck_no"
                  placeholder="truck number plate"
                  required
                />
              </div>
              <div class="form-group">
                <label>Truck license Date</label>
                <input
                  type="date"
                  class="form-control truck_license_Date"
                  :value="Truck.truck_license_Date"
                  placeholder="truck_license_Date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Trailer License date</label>
                <input
                  type="date"
                  class="form-control trailer_license_Date"
                  :value="Truck.trailer_license_Date"
                  placeholder="trailer_license_Date"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Trailer no</label>
                <input
                  type="text"
                  class="form-control trailer_no"
                  :value="Truck.trailer_no"
                  placeholder="trailer number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Truck Expiry date</label>
                <input
                  type="date"
                  class="form-control truck_expiry_date"
                  placeholder="truck expiry date"
                  :value="Truck.truck_expiry_date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Trailer Expiry date</label>
                <input
                  type="date"
                  class="form-control trailer_expiry_date"
                  :value="Truck.trailer_expiry_date"
                  placeholder="trailer_expiry_date"
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-flat updatingTruck btn-rounded"
          >
            <i class="fa fa-refresh"></i> update transporter truck
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat updatingTruckLoader btn-rounded"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i> please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import $ from "jquery";
export default {
  created() {
    if (this.$store.getters.Truck.length === 0) {
      router.push("/managetrucks");
    }
  },
  computed: {
    ...mapGetters(["Truck"]),
  },
  methods: {
    ...mapActions(["truckUpdate"]),
  },
};
</script>
<style scoped>
.updatingTruckLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucks/updatetruck.vue